import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SidebarNavigation from '../components/SidebarNavigation';
import { isAuthenticated } from '../lib/auth';

const TermsConditions = () => {
  const isAuth = isAuthenticated();

  return (
    <div className="min-h-screen bg-gray-50">
      {isAuth && <SidebarNavigation />}
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-800 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4" style={{fontFamily: 'Space Grotesk, sans-serif'}}>
            Terms & Conditions
          </h1>
          <p className="text-sm text-slate-600 mb-8">Last updated: November 2025</p>

          <div className="space-y-8 text-slate-700">
            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">1. Acceptance of Terms</h2>
              <p className="leading-relaxed">
                By accessing and using DigiDreamSolutions, you accept and agree to be bound by the terms and 
                conditions of this agreement. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">2. User Accounts</h2>
              <p className="leading-relaxed">
                You are responsible for maintaining the confidentiality of your account credentials and for all 
                activities that occur under your account. You must notify us immediately of any unauthorized use.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">3. Acceptable Use</h2>
              <ul className="list-disc list-inside space-y-2 leading-relaxed">
                <li>You may not use our services for any illegal or unauthorized purpose</li>
                <li>You may not transmit any malicious code or viruses</li>
                <li>You may not attempt to gain unauthorized access to our systems</li>
                <li>You may not use our services to spam or harass others</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">4. Intellectual Property</h2>
              <p className="leading-relaxed">
                All content, features, and functionality of DigiDreamSolutions are owned by us and are protected 
                by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">5. User Content</h2>
              <p className="leading-relaxed">
                You retain all rights to the content you create using our services. By using our platform, you 
                grant us a license to host, store, and display your content as necessary to provide our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">6. Service Availability</h2>
              <p className="leading-relaxed">
                We strive to provide uninterrupted service, but we do not guarantee that our services will always 
                be available or error-free. We may suspend or terminate services for maintenance or other reasons.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">7. Limitation of Liability</h2>
              <p className="leading-relaxed">
                DigiDreamSolutions shall not be liable for any indirect, incidental, special, consequential, or 
                punitive damages resulting from your use of or inability to use the service.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">8. Changes to Terms</h2>
              <p className="leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify users of any material 
                changes via email or through our platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-slate-900 mb-3">9. Contact Information</h2>
              <p className="leading-relaxed">
                For questions about these Terms & Conditions, contact us at:
                <br />
                <a href="mailto:legal@digidreamsolutions.com" className="text-blue-600 hover:underline">
                  legal@digidreamsolutions.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;